"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = linearGradient;
/**
 * @param {String} top - color.
 * @param {String} bottom - color.
 * @return {String} CSS background propery.
 */
function linearGradient(top, bottom) {
  return "linear-gradient(to bottom, " + top + ", " + bottom + ")";
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL3V0aWxzL2xpbmVhckdyYWRpZW50LmpzIl0sIm5hbWVzIjpbImxpbmVhckdyYWRpZW50IiwidG9wIiwiYm90dG9tIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFLd0JBLGM7QUFMeEI7Ozs7O0FBS2UsU0FBU0EsY0FBVCxDQUF3QkMsR0FBeEIsRUFBNkJDLE1BQTdCLEVBQXFDO0FBQ2xELHlDQUFxQ0QsR0FBckMsVUFBNkNDLE1BQTdDO0FBQ0QiLCJmaWxlIjoibGluZWFyR3JhZGllbnQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEBwYXJhbSB7U3RyaW5nfSB0b3AgLSBjb2xvci5cbiAqIEBwYXJhbSB7U3RyaW5nfSBib3R0b20gLSBjb2xvci5cbiAqIEByZXR1cm4ge1N0cmluZ30gQ1NTIGJhY2tncm91bmQgcHJvcGVyeS5cbiAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gbGluZWFyR3JhZGllbnQodG9wLCBib3R0b20pIHtcbiAgcmV0dXJuIGBsaW5lYXItZ3JhZGllbnQodG8gYm90dG9tLCAke3RvcH0sICR7Ym90dG9tfSlgXG59XG4iXX0=